module.exports = __webpack_public_path__ + "img/1@2x.cdf1f33c.png";